<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="keyword" :label="$t('推荐关键词')">
        <a-input v-model="form.keyword" :maxLength="100" :placeholder="$t('请输入')+$t('推荐关键词')" />
      </a-form-model-item>
      <a-form-model-item prop="searchCount" :label="$t('搜索量')">

        <a-input-number v-model="form.searchCount" style="width: 100%;" :placeholder="$t('请输入')+$t('搜索量')" />
      </a-form-model-item>
      <a-form-model-item prop="module" :label="$t('所属板块')">
        <a-radio-group v-model="form.module">
          <a-radio :value="1">
            {{$t('商城')}}
          </a-radio>
          <a-radio :value="2">
            {{$t('发现')}}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="sort" :label="$t('排序')">

        <a-input-number v-model="form.sort" style="width: 100%;" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item prop="status" :label="$t('状态')">
        <a-switch v-model="form.status"></a-switch>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('提交') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSearchRecommendWord, addSearchRecommendWord, updateSearchRecommendWord } from '@/api/search/searchRecommendWord'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        keyword: null,

        searchCount: null,

        module: null,

        status: 0,

        sort: null,

        createTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        keyword: [
          { required: true, message: this.$t('推荐关键词')+ this.$t('不能为空'), trigger: 'blur' }
        ],
        searchCount: [
          { required: true, message: this.$t('搜索量')+ this.$t('不能为空'), trigger: 'blur' }
        ],
        module: [
          { required: true, message: this.$t('所属板块') + this.$t('不能为空'), trigger: 'change' }
        ],
        status: [
          { required: true, message: this.$t('状态') + this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('排序') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        keyword: null,
        searchCount: null,
        module: null,
        status: 0,
        sort: null,
        createTime: null
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSearchRecommendWord({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSearchRecommendWord(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSearchRecommendWord(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
